export default __webpack_public_path__ + "static/media/grafema_SET_10.5451cfae.jpg";